<template lang="pug">
el-form(ref='judgmentForm', :inline='true', label-width='150px')
  proposals
  hr
  internalComments
  div(style='text-align: center')
    el-button(size='mini', type='danger', round='', @click='releaseAudit()', :disabled='false') Αποδέσμευση αίτησης
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Proposals from '../common/Proposals'
import internalComments from '../common/internalComments'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    Proposals,
    internalComments
  },
  mixins: [sharedMethods],
  mounted: function () {
  },
  props: ['application', 'comment'],
  data () {
    return {
      generalJudgment: '',
      appFinalSaved: false,
      modified: false,
      attachments: []
    }
  },
  methods: {
    releaseAudit () {
      axios.post(
        `${this.BASE_URL}/auditors/uid/applications/${this.workingApplication.id}`,
        {
          comment: null
        }
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.frontEndSuccessMsg('Η αίτηση αποδεσμεύτηκε από την λίστα ελέγχου με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την επισύναψη του αρχείου')
        this.catchError(err)
      })
    },
    // modifycomment (val) {
    //   this.modified = !(this.viewerJudgment.comment === this.comment)
    // },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    // viewerJudgment () {
    //   let h = this.application.applicationHistory
    //   return h[h.length - 1].judgment
    //   // .find(step => step.applicationStatus === 'viewerW_Proponent').judgment
    // },
    // comment () {
    //   return this.viewerJudgment.comment
    // },
    ...mapState([
      'workingApplication',
      'BASE_URL',
      'activeLane'
    ])
  },
  watch: {
    // application: function (newVal, oldVal) {
    //   this.generalJudgment = this.comment
    // },
    // comment: {
    //   handler: function (newVal, oldVal) {
    //     this.generalJudgment = newVal
    //   },
    //   deep: true
    // },
    // whenever value changes, this function will run
    // pending: (newVal, oldVal) => {
    //   if (oldVal === true) this.comment = ''
    // }
    // comment: (newComment, oldComment) => {
    //   if (newComment === 'the reason for pending') this.comment = ''
    // }
  }
}
</script>

<style scoped lang="scss">
.big {
  &.el-select {
    width: 450px;
  }
}
.biggest {
  &.el-textarea {
    width: 700px;
  }
}
.el-checkbox__label {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/AuditorJudgement.vue